var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReactivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.827 10.482a.827.827 0 100-1.654.827.827 0 000 1.654zm4.966 4.966a.827.827 0 100-1.655.827.827 0 000 1.655zM2.655 13.62a.827.827 0 100-1.654.827.827 0 000 1.655z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.827 10.482a.827.827 0 100-1.654.827.827 0 000 1.654zM6.62 14.62a.827.827 0 10-1.653 0 .827.827 0 001.654 0zm-3.965-1a.827.827 0 100-1.654.827.827 0 000 1.655zm-1.828-7a.827.827 0 100-1.654.827.827 0 000 1.655zm4.966-4.965a.827.827 0 100-1.655.827.827 0 000 1.655zM2.655 3.482a.827.827 0 100-1.655.827.827 0 000 1.655z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.827 6.62a.827.827 0 100-1.654.827.827 0 000 1.655zM6.62.827a.827.827 0 11-1.654 0 .827.827 0 011.655 0zM2.655 3.482a.827.827 0 100-1.655.827.827 0 000 1.655zM9.931 15.45a.827.827 0 01-.221-1.626 6.4 6.4 0 003.32-2.239 6.26 6.26 0 001.315-3.86 6.392 6.392 0 00-4.641-6.1.828.828 0 01.457-1.592 8.156 8.156 0 014.17 2.827 7.949 7.949 0 01.01 9.733 8.062 8.062 0 01-4.188 2.82.83.83 0 01-.228.032l.006.004z",
    fill: "#2355FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.898 16a.84.84 0 01-.092 0l-4.966-.552a.826.826 0 01-.706-1.045l1.38-4.965a.83.83 0 011.6.443l-1.12 4.028 4 .445a.827.827 0 01-.09 1.65L14.898 16z",
    fill: "#2355FC"
  })));
}

export default SvgReactivate;